export const mapObjectToFormFields = <T extends {}>(
	obj: T,
	valueCallback?: (value: T[keyof T]) => any
) =>
	Object.entries<T[keyof T]>(obj).map(([name, value]) => ({
		name,
		value: valueCallback ? valueCallback(value) : value,
	}));
